export default __webpack_public_path__ + "static/media/advantages_4.c8ec2aa2.svg";